module.exports = __webpack_public_path__ + "static/media/bookmarkIcon.bbd93e01.svg";